import { ReactNode } from 'react';

interface SalesItemWrapperProps {
  children: ReactNode;
}

export const SalesItemWrapper = ({ children }: SalesItemWrapperProps) => (
  <div className='border-greyMuted/50 pb-1 first:border-t first:pt-1 [&:not(:last-child)]:border-b'>{children}</div>
);

export const SalesItemContainer = ({ children }: SalesItemWrapperProps) => (
  <div className='flex flex-col gap-1 px-3 pb-3'>{children}</div>
);
